module.exports = __webpack_public_path__ + "static/media/whats.9af7adad.png";